import { AnyAction } from 'redux'
import { call, put, select } from 'typed-redux-saga'

import services from '@services'
import { ApplicationState } from '@store/types'
import {
  BiometricActiveValue,
  BIOMETRIC_ID_CLOUD_ACTIVE_VALUES,
  DEFAULT_BIOMETRIC_ACTIVE,
  GetBiometricActivePayload,
} from '@store/biometria/types'
import { trackingRefin } from '@store/refinanciamento/simulacao/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { StepRefin } from '@utils/enums'

import { setBiometricActive } from '../actions'

const VALID_VALUES: readonly BiometricActiveValue[] = [
  'ID_CLOUD_WITH_DOCUMENTS',
  'ID_CLOUD_WITHOUT_DOCUMENTS',
  'SERASA_WITHOUT_DOCUMENTS',
  'SERASA_WITH_DOCUMENTS',
]

export default function* getBiometricActiveSaga(receivedAction: AnyAction) {
  const payload = receivedAction.payload as GetBiometricActivePayload | undefined
  const { accessToken } = yield* select((state: ApplicationState) => state.session)

  try {
    const response = yield* call(services.getBiometricActive, accessToken)
    yield put(setLastServiceResponse({ code: 'OK', serviceName: 'getBiometricActive' }))

    const value = response.data?.value as string | undefined
    const safeValue: BiometricActiveValue =
      value && VALID_VALUES.includes(value as BiometricActiveValue)
        ? (value as BiometricActiveValue)
        : DEFAULT_BIOMETRIC_ACTIVE

    yield put(trackingRefin(StepRefin[safeValue]))
    yield put(setBiometricActive(safeValue))

    if (BIOMETRIC_ID_CLOUD_ACTIVE_VALUES.includes(safeValue)) {
      payload?.onBiometricIdCloud?.()
    }
  } catch {
    yield put(setLastServiceResponse({ code: 'ERROR', serviceName: 'getBiometricActive' }))
    yield put(trackingRefin(StepRefin.ERROR_GET_BIOMETRIC_ACTIVE))
    yield put(setBiometricActive(DEFAULT_BIOMETRIC_ACTIVE))
  }
}
